import { render, staticRenderFns } from "./InfopointLayoutsTable.vue?vue&type=template&id=6b011c52"
import script from "./InfopointLayoutsTable.vue?vue&type=script&lang=js"
export * from "./InfopointLayoutsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports